<template>
    <div :class="['p-checkbox p-component checkbox-big', {'p-checkbox-focused': focused}]"
         @click="onClick"
         @mouseleave="$refs.input.blur()">
        <div class="p-hidden-accessible">
            <input ref="input"
                   :aria-label="ariaLabel"
                   :checked="checked"
                   :disabled="disabled"
                   type="checkbox"
                   @blur="onBlur($event)"
                   @focus="onFocus($event)">
        </div>
        <div ref="box"
             :aria-checked="checked"
             :class="['p-checkbox-box p-component', {'p-highlight': checked, 'p-disabled': $attrs.disabled, 'p-focus': focused}]"
             role="checkbox">
            <span :class="['p-checkbox-icon far fa-check', {'p-checkbox-icon-visible': checked} ]"></span>
            <!--, {'pi pi-check': checked}-->
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        value: null,
        disabled: null,
        checked: null,
        ariaLabel: {
            type: String,
            default: Lang.langGet('Select')
        },
    },
    data() {
        return {
            focused: false
        }
    },
    methods: {
        onClick(event) {
            if (!this.disabled) {
                this.$emit('change', {
                    originalEvent: event,
                    data: this.value
                })

                this.$refs.input.focus()
            }
        },
        onFocus() {
            this.focused = true
        },
        onBlur() {
            this.focused = false
        }
    }
}
</script>
